<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem v-if="$route.query.name!='RCEP应用实例'">协定文本 </BreadcrumbItem>
        <BreadcrumbItem ><span v-if="$route.query.name">{{$route.query.name}}</span>协定文本 </BreadcrumbItem>
        <BreadcrumbItem >协定文本详情 </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results detail">
      <div class="results-wrap">
        <div class="results-content">
  
          <div class="maincontent boxshadow1" style="    padding: 12px 16px 18px;">
            <img :src="dataSet.coverImage" v-if="dataSet.coverImage" class="cover">
            <h1>{{dataSet.title}}</h1>
            <p class="date">{{dataSet.publishTime}}</p>
            <section style="white-space: pre-wrap;" v-html="$h.removeXSS($options.filters.convertSpace(dataSet.content))"></section>
          </div>
        </div>
        <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:50px;"></Loader>
      </div>
    </div>
  </div>
  
</template>

<script>
import Loader from '../layout/Loader'
import Siderbar from './ContentSider'

export default {
  name: 'NewsShow',
  props: ['id'],
  components: { Loader,Siderbar },
  data () {
    return {
      isShowLoader: false,
      dataSet: {}
    }
  },
  watch: {
    id (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.requestData()
      }
    },
    dataSet (newVal, oldVal) {
      if (!this._.isEmpty(newVal)) {
        this._h.setDocTitle(`${this.dataSet.title} - ${this.$t(this.$route.meta.title)} - ${this.$t('app.name')}`)
      }
    }
  },
  created () {
    this.requestData()
  },
  mounted () {
    // this.$nextTick(() => {
    //   let resultDom = document.querySelector('.results')
    //   let footer = document.querySelector('footer')
    //   resultDom.style.minHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getRealElSize(footer).height - 18)) + 'px'
    // })
  },
  methods: {
    delayRequestData () {
      setTimeout(() => {
        this.requestData()
      }, 500)
    },
    requestData () {
      if (this.isShowLoader) {
        this.delayRequestData()
        return
      }
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
     

      this.$api.query.knowledgeId(this.$route.query.id, {
        success: (response) => {
      
          this.$Loading.finish()
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data)) {
              this.dataSet = response.data.data
            } else {
              this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
          } else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    }
  }
}
</script>
<style scoped>
.breadcrumbs {
  font-size: 14px;
  color: #333;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}
.breadcrumbs >>> span span {
  color: #0470e3;
  font-weight: bold;
  cursor: default;
}
.maincontent{
  flex: 1;
  min-height:700px
}
  .results{
    position: relative;
    padding: 15px 0 20px;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: center;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  
  .results-content{
    /* width: 80%;
    margin: 0 auto; */
    width: 100%;
    position: relative;
    /* padding-left: 290px; */
    display: flex;
    /* justify-content: space-between; */
  }
  .r-sidebar{
    margin-right: 25px;
    /* position: absolute;
    top:0;
    left: 0; */
    width: 260px;
    /* min-height: 100%; */
    background-color: #fff;
  }
  h1{
    /*font-size: 1.4rem;*/
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    padding: 0 15px;
    color: #333;
    margin: 10px 0 8px;
  }
  .results-content .date{
    /*font-size: 1.1rem;*/
    font-size: 1.5rem;
    color: #999;
    text-align: center;
    margin-bottom: 15px;
  }
  .results-content >>> p{
    color: #656565;
    /*font-size: 1.3rem;*/
    font-size: 1.5rem;
    margin-bottom: 10px;
    line-height: 28px;
  }
  .results-content >>> p:last-child{
    margin-bottom: 0;
  }
  .results-content >>> img{
    display: block;
    max-width: 100%;
    margin: 15px auto;
  }
  .results-content >>> img.cover{
    margin-bottom: 20px;
    margin-top: 0;
    width: 100%;
    max-width: 1000px;
  }
  /*.results-content >>> ul{*/
    /*margin-bottom: 15px;*/
  /*}*/
  .related-links{
    border-top: 0.5px solid #E9E9E9;
    padding-top: 25px;
    margin-bottom: 20px;
    /*font-size: 1.2rem;*/
    font-size: 1.4rem;
    color: #333;
  }
  .related-links .before{
    float: left;
    width: 45%;
    padding-bottom: 2px;
  }
  .related-links .next{
    float: right;
    width: 45%;
    padding-bottom: 2px;
    text-align: right;
  }
</style>




// WEBPACK FOOTER //
// src/components/down/Show.vue